<template>
  <div class="swiper">
    <swiper class="swiper" :options="option" @mousewheel.native.prevent="mousewheel" :key="key" @mouseover.native="mouseover" @mouseout.native="mouseout">
      <swiper-slide :class="`swiper_slide`" v-for="(item,index) in data" :key="index">
        <div class="content" :title="item.mapName" @click="submit(item)">{{item.mapName}}</div>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
let that = null;
export default {
  props: {
    data: { type: Array, default: () => [] }
  },
  data() {
    return {
      key: 0,
      activeIndex: { index: 0 },
      livingExample: null, //swiper实例
      option: {}
    }
  },
  created() {
    that = this;
    this.setOption();
  },
  methods: {
    slideGo(index) { this.livingExample.slideTo(index, 300, false) },
    mousewheel(e) {
      let length = this.data.length - 15;
      if (e.deltaY > 0) {
        // 鼠标往下滚动
        this.activeIndex.index += 1;
      } else {
        // 鼠标往上滚动
        this.activeIndex.index -= 1;
      };
      let index = this.activeIndex.index;
      if (index < 0) this.activeIndex.index = 0;
      if (index > length) this.activeIndex.index = length;
      this.slideGo(this.activeIndex.index);
    },
    submit(data = {}) {
      this.$FN.limitsTips({ list: ["home_map_skip"] }).then(res => {
        if (res) {
          window.open(data.linkAddress)
        }
      });
    },
    mouseover() { this.livingExample.autoplay.stop() },
    mouseout() { this.livingExample.autoplay.start() },
    setOption() {
      this.option = {
        pagination: '.swiper-pagination',
        direction: "vertical",
        autoplay: {
          delay: 1500,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        slidesPerView: "auto",
        initialSlide: 0,
        autoHeight: true,
        spend: 300,
        preventClicks: false,
        on: {
          init: function () { that.livingExample = this },
          slideChange: function () {
            // console.log(this.activeIndex, "this.activeIndex");
            // 由于this没有指向vue实例,所以需要activeIndex中转一下
            that.activeIndex.index = this.activeIndex;
            // let { path = '' } = that.headerList[this.activeIndex];
            // if (path) that.form.moduleId = path;
            // that.getData();
          }
        }
      };
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>